import image1 from '../images/s_masonry_block_1.png';
import image2 from '../images/s_masonry_block_2.png';

export const data = [
	{
		id: 1,
		title: 'Key Service Milestone',
		desc: 'Reaching new levels of appliance efficiency together',
		img: image1,
	},
	{
		id: 2,
		title: 'Repair Hub',
		desc: 'Where repairs come to life',
		img: image2,
	},
];
